// extracted by mini-css-extract-plugin
module.exports = {"header":"TimeOffRequestsPopover_header__2nA8X","date":"TimeOffRequestsPopover_date__2fNzg"};